import { PaginatedItin } from './../../shared/models/paginated-itin.model';
import { catchError, first, tap } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';
import { environment } from 'src/environments/environment';
import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Observable, of, Subscription } from 'rxjs';
import { Poi } from 'src/app/core/poi/poi.model';
import { select } from '@angular-redux/store';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { GeoPos } from 'src/app/core/geographicalpos/geographicalpos.model';
import { GeoPosActionService } from 'src/app/core/geographicalpos/geographicalpos.action';
import { Themes } from 'src/app/core/themes/themes.model';
import { BreadcrumbService } from 'angular-crumbs';
import { ActivatedRoute, Data } from '@angular/router';
import { Itin } from 'src/app/core/itinerari/itinerari.model';
import { PoiActionService } from 'src/app/core/poi/poi.action';
import { ItinActionService } from 'src/app/core/itinerari/itinerari.action';
import { PaginatedPoi } from 'src/app/shared/models/paginated-poi.model';

@Component({
  selector: 'app-single-area',
  templateUrl: './single-area.component.html',
  styleUrls: ['./single-area.component.scss']
})
export class SingleAreaComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('map', {static: false}) mapElement: ElementRef;

  @ViewChild('themesFilterPoiDesktop') themes_filter_poi_desktop: any;
  @ViewChild('themesFilterPoiMobile') themes_filter_poi_mobile: any;
  @ViewChild('themesFilterItinDesktop') themes_filter_itin_desktop: any;
  @ViewChild('themesFilterItinMobile') themes_filter_itin_mobile: any;

  themes_filter_list_poi = [];
  themes_filter_list_itin = [];
  search_filter_text_poi = '';
  search_filter_text_itin = '';
  geopos_filter_list = [];

  @select(['poi', 'filtered'])
  poi_list_filtered$: Observable<any>;
  poi_list_filtered: Poi[] = [];
  pois_for_map: Poi[] = [];
  @select(['poi', 'total'])
  poi_list_total$: Observable<any>;
  poi_list_total: number = 0;
  @select(['poi', 'page'])
  poi_list_page$: Observable<any>;
  poi_list_page: number = 0;
  @select(['poi', 'size'])
  poi_list_size$: Observable<any>;
  poi_list_size: number = 0;


  @select(['itin', 'filtered'])
  itin_list_filtered$: Observable<any>;
  itin_list_filtered: Itin[] = [];
  @select(['itin', 'total'])
  itin_list_total$: Observable<any>;
  itin_list_total: number = 0;
  @select(['itin', 'page'])
  itin_list_page$: Observable<any>;
  itin_list_page: number = 0;
  @select(['itin', 'size'])
  itin_list_size$: Observable<any>;
  itin_list_size: number = 0;

  @select(['theme', 'list'])
  themes_list$: Observable<any>;
  themes_list: Themes[] = [];
  @select(['geopos', 'current'])
  geopos_current$: Observable<any>;
  geopos_current: GeoPos = null;

  subscriptions: Subscription[] = [];
  current_lang = 'it';

  activeInfowindow: google.maps.InfoWindow;

  geopos_center = {
    'Cimbri dell\'Altopiano dei Sette Comuni': {lat: 45.891109, lon: 11.547864, color: 'blue'},
    'Friulani in Veneto': {lat: 45.77391749995606, lon: 12.937330012651866, color: 'green'},
    'Italiani in Slovenia': {lat: 45.50906685999279, lon: 13.780505952515352, color: 'orange'},
    'Ladini del Comelico': {lat: 46.602049522923586, lon: 12.550061946245616, color: 'red'},
    'Sloveni in Italia': {lat: 45.956334177758094, lon: 13.467896260697547, color: 'lime'},
    'Friulani in Friuli Venezia Giulia': {lat: 45.956334177758094, lon: 13.467896260697547, color: 'blue_green'}
  };

  loadingPoi = false;
  loadingItin = false;
  loadingPoiThemeIcon = false;
  loadingPoiSearchIcon = false;
  loadingItinThemeIcon = false;
  loadingItinSearchIcon = false;

  constructor(private titleService: Title,
              private activateroute: ActivatedRoute,
              private poiAction: PoiActionService,
              private itinAction: ItinActionService,
              private geoposAction: GeoPosActionService,
              private breadcrumbservice: BreadcrumbService,
              private translate: TranslateService,
              private api: ApiService) {
    this.translate.setDefaultLang('it');
    if (this.translate.currentLang) {
      this.current_lang = this.translate.currentLang;
      this.translate.use(this.current_lang);
    } else {
      this.translate.use('it');
      this.current_lang = this.translate.currentLang;
    }
    this.translate.get('breadcrumb.single_area').subscribe((res: string) => {
      this.titleService.setTitle(res + ' - PRIMIS');
    });
    this.translate.onLangChange.subscribe(() => {
      this.changeLangFunction();
    });
  }

  ngOnInit(): void {
    this.activateroute.data.pipe(
      first(),
      tap((data: Data) => {
        this.pois_for_map = [...data['poisForMap']];
      })
    ).subscribe();
    this.subscriptions.push(
      this.poi_list_filtered$.subscribe((list) => {
        this.poi_list_filtered = [...list];
      }),
      this.poi_list_page$.subscribe((page) => {
        this.poi_list_page = page;
      }),
      this.poi_list_total$.subscribe((total) => {
        this.poi_list_total = total;
      }),
      this.poi_list_size$.subscribe((size) => {
        this.poi_list_size = size;
      }),
      this.itin_list_filtered$.subscribe((list) => {
        this.itin_list_filtered = [...list];
      }),
      this.itin_list_page$.subscribe((page) => {
        this.itin_list_page = page;
      }),
      this.itin_list_total$.subscribe((total) => {
        this.itin_list_total = total;
      }),
      this.itin_list_size$.subscribe((size) => {
        this.itin_list_size = size;
      }),
      this.themes_list$.subscribe((list) => {
        this.themes_list = [...list];
      }),
      this.geopos_current$.subscribe((data) => {
        this.geopos_current = data;
        if (this.geopos_current) {
          this.changeLangFunction();
        }
      }),
    );
  }

  ngAfterViewInit(): void {
    this.mapInitializer();
  }

  ngOnDestroy(): void {
    this.geoposAction.setGeoPosCurrent(null);
    this.subscriptions.forEach(x => x.unsubscribe());
  }

  mapInitializer(): void {
    const centerLat = this.geopos_center[this.geopos_current.name.it].lat;
    const centerLon = this.geopos_center[this.geopos_current.name.it].lon;
    const zoom = this.geopos_current.name.it === 'Sloveni in Italia' ? 10 : 11;
    const mapProperties = {
      center: new google.maps.LatLng(centerLat, centerLon),
      zoom,
      restriction: {
        latLngBounds: {
          north: 47,
          south: 45,
          west: 10.9,
          east: 14.6
        },
        strictBounds: false,
      },
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    };
    const map = new google.maps.Map(this.mapElement.nativeElement, mapProperties);
    this.pois_for_map.forEach(({id, poi_name, short_descr, coords}) => {
      const contentString =
        '<div id="content">' +
        '<div id="siteNotice"></div>' +
        '<h3 id="firstHeading" class="firstHeading">' + poi_name[this.current_lang] + '</h3>' +
        '<div id="bodyContent">' +
        '<p>' + short_descr[this.current_lang] + '</p>' +
        '<p><a href="' + environment.mainUrl + '/home/poi/' + id + '">Link</a></p>' +
        '</div>' +
        '</div>';

      const infowindow = new google.maps.InfoWindow({
        content: contentString,
      });
      const color = this.geopos_center[this.geopos_current.name.it].color;
      const marker = new google.maps.Marker({
        position: { lat: coords.lat, lng: coords.lon },
        map,
        icon: `/assets/map/markerPrimis_${color}.png`,
        title: poi_name[this.current_lang],
      });
      marker.addListener('click', () => {
        if (!!this.activeInfowindow) {
          this.activeInfowindow.close();
        }
        infowindow.open(map, marker);
        this.activeInfowindow = infowindow;
      });
    });
  }

  pageChange(page: number, isPoi: boolean) {
    const errorMsg = `Non è stato possibile recuperare la nuova pagina per ${isPoi ? 'i POI' : 'gli itinerari'}`;
    this.getPoiOrItin(isPoi, 'page', page - 1, errorMsg);
  }

  changeLangFunction(): void {
    this.current_lang = this.translate.currentLang;
    this.geopos_filter_list = [this.geopos_current.name[this.current_lang]];
    this.titleService.setTitle(this.geopos_current.name[this.current_lang] + ' - PRIMIS');
    this.breadcrumbservice.changeBreadcrumb(this.activateroute.snapshot, this.geopos_current.name[this.current_lang]);
    if (!!this.mapElement) {
      this.mapInitializer();
    }
  }

  inputFilter(event: Event, poi_or_itin: string) {
    const searchString = this.getSearchString((event.target as HTMLInputElement).value);
    if (poi_or_itin === 'poi') {
      const searchPoiLength = this.search_filter_text_poi.length;
      this.search_filter_text_poi = searchString;
      if (searchPoiLength !== this.search_filter_text_poi.length) {
        this.getPoiOrItin(true, 'search', 0, `Non è stato possibile cercare ${this.search_filter_text_poi} tra i POI`);
      }
    } else {
      const searchItinLength = this.search_filter_text_itin.length;
      this.search_filter_text_itin = searchString;
      if (searchItinLength !== this.search_filter_text_itin.length) {
        this.getPoiOrItin(false, 'search', 0, `Non è stato possibile cercare ${this.search_filter_text_itin} tra gli itinerari`);
      }
    }
  }

  private getSearchString(searchString: string): string {
    if (!searchString || searchString?.length < 4) {
      return '';
    }
    return searchString;
  }

  themesFilterFunction(poi_or_itin: string, isMobile: boolean) {
    if (poi_or_itin === 'poi') {
      let options_selected_poi: any[] = isMobile ?
        this.themes_filter_poi_mobile.selectedOptions.selected :
        this.themes_filter_poi_desktop.selectedOptions.selected;
      this.themes_filter_list_poi = options_selected_poi.map(({_value}) => this.getThemeIdFromName(_value, this.current_lang));
      this.getPoiOrItin(true, 'theme', 0, 'Non è stato possibile filtrare i POI per percorso tematico');
    } else {
      let options_selected_itin = isMobile ?
        this.themes_filter_itin_mobile.selectedOptions.selected :
        this.themes_filter_itin_desktop.selectedOptions.selected;
      this.themes_filter_list_itin = options_selected_itin.map(({_value}) => this.getThemeIdFromName(_value, this.current_lang));
      this.getPoiOrItin(false, 'theme', 0, 'Non è stato possibile filtrare gli itinerari per percorso tematico');
    }
  }

  private getThemeIdFromName(themeName: string, language: string): number {
    return this.themes_list.find(({name}) => name[language] === themeName).id;
  }

  togglePanel(panel_id: string) {
    this.itinAction.toggleExpandPanel(panel_id);
  }

  imageUrl(dict: Poi | Itin) {
    for (const att of dict.attachments) {
      if (att.avatar) {
        return att.file_byte;
      }
    }
    return '../../../assets/home/no-picture.png';
  }

  private getPoiOrItin(isPoi: boolean, funcType: string, page: number, errorMsg: string) {
    this.loadingSet(isPoi, funcType, true);
    if (isPoi) {
      this.api.getPoi(page, this.geopos_current.id, this.themes_filter_list_poi, this.search_filter_text_poi, this.current_lang, true)
      .pipe(
        first(),
        tap((paginatedPoi: PaginatedPoi) => {
          this.poiAction.paginatedPoiList(paginatedPoi);
          this.loadingSet(isPoi, funcType, false);
        }),
        catchError((err) => {
          console.error(errorMsg);
          this.loadingSet(isPoi, funcType, false);
          return of(err);
        })
      ).subscribe();
    } else {
      this.api.getItin(page, this.geopos_current.id, this.themes_filter_list_itin, this.search_filter_text_itin, this.current_lang, true)
      .pipe(
        first(),
        tap((paginatedItin: PaginatedItin) => {
          this.itinAction.paginatedItinList(paginatedItin);
          this.loadingSet(isPoi, funcType, false);
        }),
        catchError((err) => {
          console.error(errorMsg);
          this.loadingSet(isPoi, funcType, false);
          return of(err);
        })
      ).subscribe();
    }
  }

  private loadingSet(isPoi: boolean, funcType: string, setValue: boolean) {
    switch (funcType) {
      case 'search':
        if (isPoi) {
          this.loadingPoiSearchIcon = setValue;
        } else {
          this.loadingItinSearchIcon = setValue;
        }
        break;
      case 'theme':
        if (isPoi) {
          this.loadingPoiThemeIcon = setValue;
        } else {
          this.loadingItinThemeIcon = setValue;
        }
        break;
      default:
        if (isPoi) {
          this.loadingPoi = setValue;
        } else {
          this.loadingItin = setValue;
        }
    }
  }
}
